var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoralogix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "-1 -1 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "group-38923__Group 38923",
    className: "group-38923__Group group-38923__38923"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-38923__Group",
    className: "group-38923__Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "group-38923__Vector",
    fill: "#49BB8F",
    d: "M11 2.178c-4.856 0-8.816 3.95-8.816 8.821 0 4.871 3.947 8.822 8.816 8.822 4.856 0 8.816-3.95 8.816-8.822 0-4.87-3.947-8.821-8.816-8.821Z",
    className: "group-38923__Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "group-38923__Vector_2",
    fill: "#49BB8F",
    d: "M11 2.178C6.144 2.178 2.184 6.13 2.184 11c0 4.857 3.947 8.822 8.816 8.822 4.856 0 8.816-3.951 8.816-8.822 0-4.87-3.947-8.822-8.816-8.822ZM11 22C4.937 22 0 17.061 0 11 0 4.925 4.937 0 11 0s11 4.939 11 11-4.924 11-11 11Z",
    className: "group-38923__Vector",
    opacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoralogix);
export default __webpack_public_path__ + "static/media/Coralogix.3a6857b705d12dc81ac05c268c27bb62.svg";
export { ForwardRef as ReactComponent };